import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { GeneralInput } from "../presentational/general_text_input.jsx";
import { NumInput } from "../presentational/general_num_input.jsx";
import { ImageInput } from "../presentational/image_input.jsx";
import { AreaInput } from "../presentational/text_area_input.jsx";
import { DateInput } from "../presentational/date_input.jsx";
import SelectDropdown from "../presentational/select_dropdown.jsx";
import CheckList from "../presentational/check_list.jsx";
import { Stepper } from "../presentational/stepper.jsx";
import PlannerLead from "../presentational/planner_lead.jsx";
import { Step } from "../presentational/step.jsx";
import { KONE_PARTS_URL, EUROPE_PARTS_URL } from "../../assets/links";
import { EUROPE_EQUIPMENT_LOCATION_COUNTRY_CODES } from "../../assets/countryCodes";
import PreviousResponse from "../previous-response/previous_response.jsx";

import authService from "../../services/auth";

let sessionRefreshInterval = undefined;

export class SiteSurveyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  async componentDidMount() {
    await authService.verifyUserLoggedIn(true); // Ensuring that the session is refreshed on getting to the survey page

    sessionRefreshInterval = setInterval(async () => {
      await authService.verifyUserLoggedIn(true);
    }, 3000000); // Refresh call to be made after every 50 minutes (Timeout being 1 hour).
  }

  componentWillUnmount() {
    if (sessionRefreshInterval != undefined) {
      clearInterval(sessionRefreshInterval);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.previousFormState !== this.props.previousFormState) {
      this.setState({ previousFormState: this.props.previousFormState });
    }
  }

  valueOfField(fieldId) {
    if (this.props.formState[fieldId] == undefined) return undefined;

    return this.props.formState[fieldId].value;
  }

  getSharedSelectionOptionTranslations(field) {
    var tranlationsDictionary = {};
    field.options.forEach((key) => {
      var keyAsString = String(key);
      if (this.props.strings?.sharedSelectionOptions[keyAsString]) {
        tranlationsDictionary[keyAsString] =
          this.props.strings?.sharedSelectionOptions[keyAsString];
      }
    });
    if (Object.keys(tranlationsDictionary).length !== field.options.length) {
      console.error("Could not find translations");
      console.error("Translations that script was looking for:");
      console.error(field.options);
      console.error("Shared selection options:");
      console.error(this.props.strings?.sharedSelectionOptions);
      return null;
    }
    return tranlationsDictionary;
  }

  getStrings(field) {
    let translationString = this.props.strings?.options?.[field.id];
    if (translationString === undefined) {
      translationString = this.getSharedSelectionOptionTranslations(field);
    }
    return translationString;
  }

  onBoxChecked(value) {
    this.props.onBoxChecked(value);

    this.setState({
      [value]: this.state[value] ? false : true,
    });
  }

  conditionsMet(field) {
    if (field.requiresCheckBox && field.requiresCheckBox.length > 0) {
      for (
        var i_condition = 0;
        i_condition < field.requiresCheckBox.length;
        i_condition++
      ) {
        var requiredCheckBox = field.requiresCheckBox[i_condition];
        if (!this.state[requiredCheckBox]) return false;
      }
    }

    if (field.notAllowedCheckBox && field.notAllowedCheckBox.length > 0) {
      for (
        var i_condition = 0;
        i_condition < field.notAllowedCheckBox.length;
        i_condition++
      ) {
        var requiredCheckBox = field.notAllowedCheckBox[i_condition];
        if (this.state[requiredCheckBox]) return false;
      }
    }

    if (field?.selectionConditionId && field?.selectionConditions) {
      const conditionId = field?.selectionConditionId;
      const conditions = field?.selectionConditions;
      return this.props.formState[conditionId]?.value &&
        conditions &&
        Array.isArray(conditions) &&
        conditions.indexOf(this.props.formState[conditionId].value) > -1
        ? true
        : false;
    }

    return true;
  }

  getPreviews(id) {
    if (this.props.formState[id] && this.props.formState[id].images)
      return this.props.formState[id].images;
    else return null;
  }

  getLeadFromPreviousSurvey(field) {
    const id = field.selectionConditionId || field.checkBoxSelectionId;
    // Init new Planner Lead (needed for mandatory field checks)
    /* if (!this.props.previousPlannerLeads[id]) {
      this.props.onPlannerLeadChanged(id, "init", null);
    } */
    return this.props.previousPlannerLeads[id]
      ? this.props.previousPlannerLeads[id]
      : null;
  }

  getCorrectLead(field) {
    const id = field.selectionConditionId || field.checkBoxSelectionId;
    // Init new Planner Lead (needed for mandatory field checks)
    if (!this.props.plannerLeads[id]) {
      this.props.onPlannerLeadChanged(id, "init", null);
    }
    return this.props.plannerLeads[id] ? this.props.plannerLeads[id] : null;
  }

  plannerLeadVisible(field) {
    const conditionId = field?.selectionConditionId;
    const conditions = field?.selectionConditions;
    let plannerLeadShouldBeVisible =
      this.props.formState[conditionId]?.value &&
      conditions &&
      Array.isArray(conditions) &&
      conditions.indexOf(this.props.formState[conditionId].value) > -1
        ? true
        : false;
    if (
      field.isOlderThanYears &&
      this.props.formState[field.selectionConditionId]?.value &&
      this.props.formState[field.selectionConditionId]?.value.toString()
        .length === 4
    ) {
      const yearDifference =
        new Date().getFullYear() -
        Number(this.props.formState[field.selectionConditionId].value);
      plannerLeadShouldBeVisible = yearDifference > field.isOlderThanYears;
    }
    return plannerLeadShouldBeVisible;
  }

  getPSRpackageLink() {
    const equipment = this.props.equipment;
    if (
      equipment &&
      EUROPE_EQUIPMENT_LOCATION_COUNTRY_CODES.includes(
        equipment.EquipmentLocationCompanyCode,
      )
    ) {
      return EUROPE_PARTS_URL;
    }
    return KONE_PARTS_URL;
  }

  render() {
    return (
      <div>
        <Stepper
          conditionsMet={this.conditionsMet.bind(this)}
          disabled={this.props.disabled}
          formState={this.props.formState}
          strings={this.props.commonStrings}
        >
          {this.props.formLayout.map((stepItem, index) => {
            return (
              <Step
                key={index}
                stepItem={stepItem}
                title={this.props.strings.stepTitles[stepItem.step]}
              >
                <div className="input-form" key={index}>
                  {stepItem.fields.map((field, index) => {
                    let previousResponse =
                      this.props?.previousFormState?.[field.id]?.value || null;
                    let PREVIOUS_RESPONSE = previousResponse;
                    if (
                      field.type === "dropdown" &&
                      field.options &&
                      field.options.length > 0
                    ) {
                      const strings = this.getStrings(field);
                      const PREVIOUS_RESPONSE_TRANSLATION =
                        strings?.[previousResponse] || null;
                      PREVIOUS_RESPONSE = PREVIOUS_RESPONSE_TRANSLATION;
                    }
                    const lastSurveyResponseHeader =
                      this.props.commonStrings?.lastSurveyResponse ||
                      "Last survey response:";

                    if (
                      this.props.formState[field.id] &&
                      this.props.formState[field.id].hidden
                    )
                      return null;

                    if (!this.conditionsMet(field)) return null;

                    switch (field.type) {
                      case "dropdown":
                        const strings = this.getStrings(field);
                        return (
                          <div key={`dropdown-${field.id}`}>
                            <SelectDropdown
                              id={field.id}
                              strings={strings}
                              title={this.props.strings.fields[field.id]}
                              value={this.props.formState[field.id] || ""}
                              options={field.options}
                              mandatory={false}
                              onValueChange={(valueObj) =>
                                this.props.onValueChange(field, valueObj)
                              }
                              default={this.props.strings?.selectValue}
                              enableClearSelection={
                                field.enableClearSelection || false
                              }
                              clearSelectionText={
                                this.props.strings?.sharedSelectionOptions[
                                  "CLEAR"
                                ] || null
                              }
                              other={{
                                otherOption: field.otherOption, //enum
                                otherText: this.props.strings?.other,
                                otherField: field.otherField, //true or false
                                otherFieldTitle: this.props.strings?.otherWhat,
                              }}
                              lastSurveyResponseHeader={
                                lastSurveyResponseHeader
                              }
                              lastSurveyResponseText={PREVIOUS_RESPONSE}
                            />
                          </div>
                        );

                        break;
                      case "conditionalComponent":
                        return (
                          field.component === "planner-lead" &&
                          this.plannerLeadVisible(field) && (
                            <PlannerLead
                              key={index}
                              id={field.id}
                              onPlannerLeadChanged={(selection, type, value) =>
                                this.props.onPlannerLeadChanged(
                                  selection,
                                  type,
                                  value,
                                )
                              }
                              previousPlannerLead={this.getLeadFromPreviousSurvey(
                                field,
                              )}
                              plannerLead={this.getCorrectLead(field)}
                              psrPackageUrl={this.getPSRpackageLink()}
                              selection={
                                field.selectionConditionId ||
                                field.checkBoxSelectionId
                              }
                              translations={this.props.plannerLeadsStrings}
                              responseHeader={lastSurveyResponseHeader}
                              relatedQuestionTranslation={
                                this.props.strings.fields[
                                  field?.selectionConditionId
                                ]
                              }
                            />
                          )
                        );
                        break;
                      case "date":
                        return (
                          <DateInput
                            label={this.props.strings.fields[field.id]}
                            key={index}
                            onValueChange={(valueObj) => this.props.onValueChange(field, valueObj)}
                            initValue={
                              this.props.formState[field.id]
                                ? this.props.formState[field.id].value || ""
                                : ""
                            }
                            lastSurveyResponseHeader={
                              lastSurveyResponseHeader
                            }
                            lastSurveyResponseText={PREVIOUS_RESPONSE}
                          />
                        );
                      case "number":
                        return (
                          <>
                            {
                              PREVIOUS_RESPONSE && Number(PREVIOUS_RESPONSE.quantity) > 0 ? (
                                <PreviousResponse
                                  responseHeader={lastSurveyResponseHeader}
                                  responseText={PREVIOUS_RESPONSE}
                                />
                              ) : null
                            }
                            <NumInput
                              id={field.id}
                              key={index}
                              label={this.props.strings.fields[field.id]}
                              min={field.min}
                              max={field.max}
                              units={"METRIC"}
                              labelDetail={field.label}
                              maxLength={field.maxLength}
                              onInputChange={(valueObj) => this.props.onValueChange(field, valueObj)}
                              value={
                                this.props.formState[field.id]
                                  ? this.props.formState[field.id].value || ""
                                  : ""
                              }
                              valid={
                                this.props.formState[field.id] && this.props.formState[field.id].valid
                              }
                              validityTester={
                                field.validityRegExp
                                  ? (input) => field.validityRegExp.test(input)
                                  : null
                              }
                              helpText={
                                field.helpText ? this.props.strings.fields[field.helpText] : null
                              }
                            />
                          </>
                        );
                        break;
                      case "text":
                        return (
                          <>
                            {PREVIOUS_RESPONSE && (
                              <PreviousResponse
                                responseHeader={lastSurveyResponseHeader}
                                responseText={PREVIOUS_RESPONSE}
                              />
                            )}
                            <GeneralInput
                              id={field.id}
                              key={index}
                              label={this.props.strings.fields[field.id]}
                              onInputChange={(value) =>
                                this.props.onValueChange(field, { value })
                              }
                              value={
                                this.props.formState[field.id]
                                  ? this.props.formState[field.id].value || ""
                                  : ""
                              }
                            />
                          </>
                        );
                        break;
                      case "image":
                        return (
                          <ImageInput
                            id={field.id}
                            title={
                              field.showTitle
                                ? this.props.strings.fields[field.id]
                                : null
                            }
                            key={index}
                            onDrop={(files) =>
                              this.props.onImageDrop(files, field.id)
                            }
                            mandatory={field.id === "carPictureCopKen"}
                            previews={this.getPreviews(field.id)}
                            label={this.props.strings?.selectImage}
                            helpText={
                              field.helpText
                                ? this.props.strings.fields[field.helpText]
                                : null
                            }
                            addImageButtonText={this.props.commonStrings?.addImage}
                            imgHelptext={this.props.commonStrings?.imageFromLastSurvey}
                            uploadSuccessful={
                              this.props.formState[field.id] &&
                              this.props.formState[field.id].image &&
                              this.props.formState[field.id].image
                                .uploadSuccesfull != undefined
                                ? this.props.formState[field.id].image
                                    .uploadSuccesfull
                                : true
                            }
                            failText={this.props.strings?.imageUpload?.fail}
                            instructionText={
                              field.instructionText
                                ? this.props.strings.fields[
                                    field.instructionText
                                  ]
                                : null
                            }
                            onImageClick={(image, fieldId) =>
                              this.props.onImageClicked(image, fieldId)
                            }
                          />
                        );
                        break;
                      case "text-area":
                        return (
                          <>
                            {PREVIOUS_RESPONSE && (
                              <PreviousResponse
                                responseHeader={lastSurveyResponseHeader}
                                responseText={PREVIOUS_RESPONSE}
                              />
                            )}
                            <AreaInput
                              id={field.id}
                              key={index}
                              label={
                                field.translationKey
                                  ? this.props.strings.fields[
                                      field.translationKey
                                    ]
                                  : this.props.strings.fields[field.id]
                              }
                              helpText={
                                field.helpText
                                  ? this.props.strings.fields[field.helpText]
                                  : null
                              }
                              onInputChange={(value) =>
                                this.props.onValueChange(field, { value })
                              }
                              value={
                                this.props.formState[field.id]
                                  ? this.props.formState[field.id].value || ""
                                  : ""
                              }
                              maxLength={"2000"}
                            />
                          </>
                        );
                        break;
                      case "checkboxes":
                        return (
                          <>
                            {this.props.showCheckBoxes && (
                              <CheckList
                                key={index}
                                options={Object.keys(
                                  this.props.strings?.checkBoxes,
                                )
                                  .filter((i) => {
                                    return (
                                      i == "hasBeenModernized" ||
                                      i == "hasMachineRoom" ||
                                      i == "isHydraulicElevator" ||
                                      i == "hasInverterDrive" ||
                                      i == "hasGearedMachine"
                                    );
                                  })
                                  .map((i) => {
                                    return {
                                      text: this.props.strings?.checkBoxes[i],
                                      key: i,
                                    };
                                  })}
                                onBoxChecked={(value) =>
                                  this.onBoxChecked(value)
                                }
                              />
                            )}
                          </>
                        );
                        break;
                    }
                  })}
                </div>
              </Step>
            );
          })}
        </Stepper>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(null, mapDispatchToProps)(SiteSurveyForm);
